const { InspectorControls } = wp.blockEditor;
const { PanelBody } = wp.components;
import ImageControl from '../wp-controlers/mediaUpload';
import CommonPanel from '../wp-controlers/common-panel';

const Inspector = ({ attributes, setAttributes }) => {
  return (
    <InspectorControls>
      <PanelBody>
        <ImageControl
          image="image"
          attributes={attributes}
          setAttributes={setAttributes}
        />
      </PanelBody>

      <CommonPanel attributes={attributes} setAttributes={setAttributes} />
    </InspectorControls>
  );
};

export default Inspector;
